<template>
  <div class="herodiv" :class="{loaded: loaded}">
    <div class="onediv" >
      <div class="square-im" v-on:click="$emit('zoom')">
        <a :href="permalink" v-on:click.prevent><img v-if="seen" :src="imageUrl" :alt="item.image.alt" v-on:load="loaded=true" /></a>
        <div class="hover-alink">
          <div v-html="imageTitle"></div>
          <div style="margin-top:10px">
            <small-button large 
              v-on:click="$emit('zoom')">{{ $nippets.portfolio.view }}</small-button>
          </div>
          <permalink-button :image="item.image" :artist="item.artist" small class="hmv" />
        </div>
      </div>
      <div class="sbar-x">
        <div class="hi-artist-name" v-on:click.stop="visitPortfolio">
          <div class="portrait"><img :src="portraitUrl" :alt="item.artist.az_alt"></div>
          <ix-router-link :to="portfolioUrl" v-on:click.stop class="name-elip">{{ item.artist.formatted_name }}</ix-router-link>
        </div>
        <div class="rbox"><like-box :imageId="item.image.image_id" /></div>
      </div>
    </div>
  </div>
</template>

<script>
import ViewablePanel from '@/mixins/ViewablePanel.js'
import PermalinkButton from '@/components/buttons/PermalinkButton.vue'
import LikeBox from '@/components/buttons/LikeBox.vue'

export default {
  components: {
    PermalinkButton,
    LikeBox
  },
  // item is a home-page-image
  props: {
    item: Object
  },
  data () {
    return {
      loaded: false
    }
  },
  mixins: [ViewablePanel],
  computed: {
    imageUrl () {
      return this.$k.getImageCrop500(this.item.image.url)
    },
    permalink () {
      return this.$k.getImagePermalink(this.item.image, this.item.artist)
    },
    firstName () {
      return this.item.artist.formatted_name.split(' ')[0]
    },
    portfolioUrl () {
      return this.$k.getPortfolioLink(this.item.artist)
    },
    imageTitle () {
      return this.$k.getImAttr(this.item.image, 'detail.title')
    },
    portraitUrl () {
      if(this.item.artist) {
        return this.$k.getArtistPortraitUrl(this.item.artist.portfolio_url)
      }
      return ''
    }
  },
  methods: {
    visitPortfolio () {
      this.$ixr.push(this.portfolioUrl)
    }
  }
}
</script>

<style>
img.main{
  position:absolute;
  top:50%;
  left:50%;
  width:100%;
  transform:translate(-50%,-50%);
  transition:all 0.3s ease;
}
.square-filler{
  position:relative;
  overflow:hidden;
}
.imdiv:hover img.main{
  width:107%;
}


.herodiv{
  display:inline-flex;
  background-color:#efefea;
  padding:0 0 10px 0;
  margin-bottom:20px;
  width:24%;
  opacity:0;
  transition:all 0.3s ease;
  transform:scale(0.5);
}

.herodiv.loaded{
  opacity:1;
  transform:scale(1.0);
}

.onediv{
  width:100%;
  position:relative;
}

.square-im{
  width:100%;
  cursor:pointer;
  position:relative;
  overflow:hidden;
}

.square-im img{
  width:100%;
  transition:all 0.25s ease-in-out;
}

.square-im:hover img{
  transform: scale(1.1);
}

.sbar-x{
  position:relative;
  min-height:24px;
  display:flex;
  justify-content: space-between;
  margin:5px 10px 0 10px;
  box-sizing: border-box;
}

.hi-artist-name{
  font-size: 20px;
  font-weight:500;
  display:flex;
  align-items: center;
  cursor:pointer;
  max-width:calc(100% - 30px);
  box-sizing: border-box;
}

.name-elip{
  overflow:hidden;
  white-space:nowrap;
  text-overflow:ellipsis;
  display:inline-block;
}


.hover-alink{
  position:absolute;
  bottom:-100px;
  left:0;
  padding:10px;
  background-color:#efefea;
  box-sizing: border-box;
  width:100%;
  transition: all 0.4s ease;
}

.square-im:hover .hover-alink{
  bottom:0;
}

a.permalink.hmv{
  right:15px;
}

.hi-artist-name .portrait{
  width:40px;
  height:40px;
  border-radius:50%;
  overflow:hidden;
  margin-right:10px;
  transition:all 0.3s ease;
  flex-shrink:0;
}

.hi-artist-name:hover  .portrait{
  transform: scale(1.3);
}

.hi-artist-name .portrait img{
  width:100%;
  height:100%;
  object-fit:cover;
}

.sbar-x .rbox{
  display:flex;
  align-items:center;
}


@media screen and (max-width:1300px){
  .herodiv{
    width:32%;
  }
  
}

@media screen and (max-width:960px){
  .herodiv{
    width:49%;
  }
}

@media screen and (max-width:640px){
  .herodiv{
    width:100%;
  }
  .hi-artist-name{
    font-size: 17px;
  }
  
}

@media screen and (max-width:420px){

}
</style>